import React, { useEffect, useState } from "react"
import './style.css';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import Sidebar from "../Components/Sidebar/Sidebar";
import Topbar from "../Components/Topbar/Topbar";
import RegularClasses from "../Components/ClassesListing/RegularClasses";
import FlexClasses from "../Components/ClassesListing/FlexClasses";
import userAction from "../actions/userActions";
import { connect } from "react-redux";
import GroupedClasses from "../Components/ClassesListing/GroupedClasses";
import FlexGroupedClasses from "../Components/ClassesListing/FlexGroupedClasses";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const Listing = (props) => {
  const [key, setKey] = useState('regular')
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSubmitFlex, setIsSubmitFlex] = useState(false);
  const [selectArray, setSelectArray] = useState([]);
  const [isRegular, setIsRegular] = useState(false);
  const [isFlex, setIsFlex] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [processData, setProcessData] = useState([]);
  const [selectRegularArr, setSelectRegularArr] = useState([]);
  const [approvedRegArr, setApprovedRegArr] = useState([]);
 

  useEffect(() => {
  }, [key])


  
  const conditionalRowStyles = [
    {
      when: row => row.runtime < 100,
      style: {
        backgroundColor: 'green',
        color: 'white',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
    {
      when: row => row.runtime < 150 && row.runtime > 100,
      style: row => ({ backgroundColor: 'pink' }),
    },
  ];

  useEffect(() => {
    if (isSubmit == true) {
      if (selectArray.length > 0) {
        setSelectArray(selectArray)
      }
    }
  }, [isSubmit])


  return (
    <>
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <Tabs
                    onSelect={(e) => setKey(e)}
                    activeKey={key}
                    id="uncontrolled-tab-example"
                    className=" setting"
                    justify
                  >
                    <Tab eventKey="regular" title="Regular Students">
                      {isSubmit == false ?
                        <RegularClasses
                          isSubmit={isSubmit}
                          setIsSubmit={setIsSubmit}
                          setSelectArray={setSelectArray}
                          setIsRegular={setIsRegular}
                          setProcessData={setProcessData}
                          setSelectRegularArr={setSelectRegularArr}
                          approvedRegArr={approvedRegArr}
                        />
                        : (isSubmit == true && isRegular == true) &&
                        <>
                          <RegularClasses
                            isSubmit={isSubmit}
                            setIsSubmit={setIsSubmit}
                            setSelectArray={setSelectArray}
                            setIsRegular={setIsRegular}
                            setProcessData={setProcessData}
                            setSelectRegularArr={setSelectRegularArr}
                            approvedRegArr={approvedRegArr}
                          />
                          <br />
                          <GroupedClasses
                            selectRegularArr={selectRegularArr}
                            selectArray={selectArray}
                            key={selectArray.length}
                            processData={processData}
                            setApprovedRegArr={setApprovedRegArr}
                            
                          />
                        </>
                      }
                    </Tab>
                    <Tab eventKey="flex" title="Flex Students" >
                      {isSubmitFlex == false ?
                        <FlexClasses
                          isSubmitFlex={isSubmitFlex}
                          setIsSubmitFlex={setIsSubmitFlex}
                          setSelectArray={setSelectArray}
                          setIsFlex={setIsFlex}
                        />
                        : (isSubmitFlex == true && isFlex == true) &&
                        <>
                          <FlexClasses
                            isSubmitFlex={isSubmitFlex}
                            setIsSubmitFlex={setIsSubmitFlex}
                            setSelectArray={setSelectArray}
                            setIsFlex={setIsFlex}
                          />
                          <br />
                          <FlexGroupedClasses
                            selectArray={selectArray}
                            key={selectArray.length}
                          />
                        </>
                      }
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
// export default Listing

const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    // userdata: state.userInfo,
    apiToken: state.apiToken
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Listing);
